import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import { AdminUser } from 'models/adminUser';
import { Group } from 'models/group';

import { Container, Items, Item } from './styles';

interface Props {
  show: boolean;
  value: any;
  groups?: Group[];
  users?: AdminUser[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: string) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectGroups = ({ show, groups, users, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isActive = useCallback((item: Group | AdminUser) => item.id === value, [value]);

  const handleItemClick = (id: string) => {
    if (id !== value) {
      onChange(id);
    }
    onClose();
  };

  const makeText = (group: Group) => `${group.name}  (${group.users.length})`;

  const makeUserName = (user: AdminUser) => `${user.name} ${user.lastName}`;

  return show ? (
    <Container>
      <Items>
        {groups
          ? groups.map((group) => (
              <MakeItem
                key={group.id}
                className={isActive(group) ? 'active' : ''}
                text={makeText(group)}
                onClick={() => handleItemClick(group.id)}
              />
            ))
          : users &&
            users.map((user) => (
              <MakeItem
                key={user.id}
                className={isActive(user) ? 'active' : ''}
                text={makeUserName(user)}
                onClick={() => handleItemClick(user.id || '')}
              />
            ))}
      </Items>
    </Container>
  ) : null;
};

export default SelectGroups;
